import * as React from 'react';

import { Box, Card, CardContent, CardHeader, Typography } from '@mui/material';
import {
  EditButton,
  RecordContextProvider,
  TextField,
  useListContext,
  useTranslate,
} from 'react-admin';

import AvatarField from './AvatarField';
import { Customer } from '../../types';
import DisscountReferenceField from './DiscountReferenceField';

const MobileGrid = () => {
  const translate = useTranslate();
  const { data, isLoading } = useListContext<Customer>();

  if (isLoading || data.length === 0) {
    return null;
  }

  return (
    <Box margin="0.5em">
      {data.map((record) => (
        <RecordContextProvider key={record.id} value={record}>
          <Card sx={{ margin: '0.5rem 0' }}>
            <CardHeader
              title={`${record.name} (${record.companyName})`}
              avatar={<AvatarField size="45" />}
              action={<EditButton />}
            />
            <CardContent sx={{ pt: 0 }}>
              <Typography variant="body2">
                {translate('resources.customers.fields.phone_number')}
                :&nbsp;
                <TextField source="phone" />
              </Typography>
              <Typography variant="body2">
                {translate('resources.customers.fields.discount')}
                :&nbsp;
                <DisscountReferenceField record={record} />
              </Typography>
            </CardContent>
          </Card>
        </RecordContextProvider>
      ))}
    </Box>
  );
};

export default MobileGrid;
